export const coursesData = [
  {
    name: "Γραμμική Άλγεβρα",
    code: "Κ03",
    ECTS: "6",
    category: "ΥΜ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Διακριτά Μαθηματικά",
    code: "Κ09",
    ECTS: "7",
    category: "ΥΜ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Εισαγωγή στην Πληροφορική και στις Τηλεπικοινωνίες",
    code: "ΓΠ07",
    ECTS: "2",
    category: "ΓΠ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Εισαγωγή στον Προγραμματισμό",
    code: "Κ04",
    ECTS: "7",
    category: "ΥΜ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Εργαστήριο Λογικής Σχεδίασης",
    code: "K02ε",
    ECTS: "2",
    category: "ΕΡ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Λογική Σχεδίαση",
    code: "Κ02",
    ECTS: "6",
    category: "ΥΜ",
    semester: "1",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Ανάλυση Ι",
    code: "Κ01",
    ECTS: "8",
    category: "ΥΜ",
    semester: "2",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Αρχιτεκτονική Υπολογιστών Ι",
    code: "Κ14",
    ECTS: "7",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "2"
  },
  {
    name: "Δομές Δεδομένων και Τεχνικές Προγραμματισμού",
    code: "Κ08",
    ECTS: "7",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "2"
  },
  {
    name: "Εφαρμοσμένα Μαθηματικά",
    code: "Κ20β",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "2"
  },
  {
    name: "Ηλεκτρομαγνητισμός – Οπτική και Σύγχρονη Φυσική",
    code: "Κ12",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "2"
  },
  {
    name: "Ανάλυση ΙΙ",
    code: "Κ06",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "3"
  },
  {
    name: "Αντικειμενοστραφής Προγραμματισμός",
    code: "Κ10",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "3"
  },
  {
    name: "Εργαστήριο Κυκλωμάτων και Συστημάτων",
    code: "Κ11ε",
    ECTS: "2",
    category: "ΕΡ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "3"
  },
  {
    name: "Πιθανότητες και Στατιστική",
    code: "Κ13",
    ECTS: "6",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "3"
  },
  {
    name: "Σήματα και Συστήματα",
    code: "Κ11",
    ECTS: "6",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "3"
  },
  {
    name: "Αλγόριθμοι και Πολυπλοκότητα",
    code: "Κ17",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "4"
  },
  {
    name: "Δίκτυα Επικοινωνιών I",
    code: "Κ16",
    ECTS: "6",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "4"
  },
  {
    name: "Εργαστήριο Δικτύων Επικοινωνιών Ι",
    code: "Κ16ε",
    ECTS: "2",
    category: "ΕΡ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "4"
  },
  {
    name: "Συστήματα Επικοινωνιών",
    code: "Κ21",
    ECTS: "7",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "4"
  },
  {
    name: "Σχεδίαση και Χρήση Βάσεων Δεδομένων",
    code: "Κ29",
    ECTS: "7",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "4"
  },
  {
    name: "Αριθμητική Ανάλυση",
    code: "Κ15",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "Υ",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Αρχές Γλωσσών Προγραμματισμού",
    code: "ΘΠ01",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Αρχιτεκτονική Υπολογιστών ΙΙ",
    code: "Κ30",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "Υ",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Γραφικά Ι",
    code: "ΘΠ02",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "5"
  },
  {
    name: "Δίκτυα Επικοινωνιών II",
    code: "Κ33",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "Υ",
    s6: "",
    semester: "5"
  },
  {
    name: "Κύματα, Κυματοδηγοί, Κεραίες",
    code: "ΕΠ05",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "B",
    s6: "",
    semester: "5"
  },
  {
    name: "Λειτουργικά Συστήματα",
    code: "Κ22",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Παράλληλα Συστήματα",
    code: "ΘΠ04",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "B",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Σχεδίαση Ψηφιακών Συστημάτων - VHDL",
    code: "ΥΣ03",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Τεχνητή Νοημοσύνη I",
    code: "ΥΣ02",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "B",
    s3: "B",
    s4: "",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Τηλεπικοινωνιακά Δίκτυα",
    code: "ΕΠ20",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "B",
    s6: "",
    semester: "5"
  },
  {
    name: "Υλοποίηση Συστημάτων Βάσεων Δεδομένων",
    code: "Κ18",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "Υ",
    s3: "Υ",
    s4: "",
    s5: "",
    s6: "",
    semester: "5"
  },
  {
    name: "Ψηφιακή Επεξεργασία Σήματος",
    code: "Κ32",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "Υ",
    semester: "5"
  },
  {
    name: "Αναγνώριση Προτύπων–Μηχανική Μάθηση",
    code: "ΕΠ08",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "6"
  },
  {
    name: "Ανάλυση/Σχεδίαση Συστημάτων Λογισμικού",
    code: "ΥΣ04",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Ασύρματα Δίκτυα Αισθητήρων",
    code: "ΥΣ18",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "B",
    s6: "",
    semester: "6"
  },
  {
    name: "Διαχείριση Δικτύων",
    code: "Κ34",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "Υ",
    s6: "",
    semester: "6"
  },
  {
    name: "Ειδικά Θέματα Επικοινωνιών και Επεξεργασίας Σήματος – Πολυμέσα και Ασύρματη Δικτύωση",
    code: "ΕΠ22β",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Επεξεργασία Στοχαστικών Σημάτων",
    code: "ΕΠ07",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "B",
    s6: "B",
    semester: "6"
  },
  {
    name: "Επιστημονικοί Υπολογισμοί",
    code: "ΘΠ03",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Εργαστήριο Ηλεκτρονικής",
    code: "Κ19ε",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Ηλεκτρονική",
    code: "K19",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "Υ",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Θεωρία Πληροφορίας και Κωδίκων",
    code: "Κ35",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "Υ",
    semester: "6"
  },
  {
    name: "Θεωρία Υπολογισμού",
    code: "Κ25",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "",
    s2: "Υ",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Λογικός Προγραμματισμός",
    code: "ΥΣ05",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Μαθηματικά Πληροφορικής",
    code: "Κ20α",
    ECTS: "6",
    category: "ΕΥΜ",
    s1: "Υ",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Μεταγλωττιστές",
    code: "Κ31",
    ECTS: "6",
    category: "ΕΥΜ",
    semester: "6",
    s1: "",
    s2: "",
    s3: "Υ",
    s4: "B",
    s5: "",
    s6: "",
  },
  {
    name: "Προγραμματισμός Συστήματος",
    code: "Κ24",
    ECTS: "8",
    category: "ΥΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Τεχνητή Νοημοσύνη ΙΙ (Βαθιά Μηχανική Μάθηση για την Επεξεργασία Φυσικής Γλώσσας)",
    code: "ΥΣ19",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Τεχνικές Εξόρυξης Δεδομένων",
    code: "ΥΣ11",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Αλγόριθμοι - Θεμελιώσεις Μηχανικής Μάθησης",
    code: "ΘΠ22",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "6"
  },
  {
    name: "Τεχνολογίες Εφαρμογών Διαδικτύου",
    code: "ΥΣ14",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "",
    s5: "B",
    s6: "",
    semester: "6"
  },
  {
    name: "Αλγοριθμική Επιχειρησιακή Έρευνα",
    code: "ΘΠ09",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "7"
  },
  {
    name: "Ανάπτυξη Λογισμικού για Αλγοριθμικά Προβλήματα",
    code: "Κ23γ",
    ECTS: "8",
    category: "P",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ανάπτυξη Λογισμικού για Πληροφοριακά Συστήματα",
    code: "Κ23α",
    ECTS: "8",
    category: "P",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ανάπτυξη Λογισμικού για Συστήματα Δικτύων και Τηλεπικοινωνιών",
    code: "Κ23β",
    ECTS: "8",
    category: "P",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Διδακτική της Πληροφορικής",
    code: "ΥΣ10",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Δομή και Θεσμοί της Ευρωπαϊκής Ένωσης",
    code: "ΓΠ03",
    ECTS: "2",
    category: "ΓΠ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ειδικά Θέματα Επικοινωνιών και Επεξεργασίας Σήματος: Ειδικά Θέματα Κβαντικής Πληροφορίας και Υπολογιστικής",
    code: "ΕΠ22δ",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ειδικά Θέματα Επικοινωνιών και Επεξεργασίας Σήματος: Βαθιά Μάθηση",
    code: "ΕΠ22στ",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ειδικά Θέματα Υπολογιστικών Συστημάτων και Εφαρμογών",
    code: "ΥΣ16",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ειδικά Θέματα Υπολογιστικών Συστημάτων και Εφαρμογών – Τεχνολογίες Γνώσεων",
    code: "ΥΣ16β",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ενισχυτική Μηχανική Μάθηση και Στοχαστικά Παίγνια",
    code: "ΕΠ22α",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Επικοινωνία Ανθρώπου Μηχανής",
    code: "ΥΣ08",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "B",
    s3: "B",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ηλεκτρονική Διακυβέρνηση",
    code: "ΥΣ17",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Θεωρία Αριθμών",
    code: "ΘΠ08",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Οπτικές Επικοινωνίες και Οπτικά Δίκτυα",
    code: "ΕΠ16",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "B",
    s6: "",
    semester: "7"
  },
  {
    name: "Πληροφοριακά Συστήματα",
    code: "ΥΣ07",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Προηγμένα Θέματα Αλγορίθμων",
    code: "ΘΠ12",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Προηγμένοι Επιστημονικοί Υπολογισμοί",
    code: "ΘΠ18",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Συστήματα Κινητών και Προσωπικών Επικοινωνιών",
    code: "ΕΠ18",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "B",
    s6: "",
    semester: "7"
  },
  {
    name: "Συστήματα Ψηφιακής Επεξεργασίας Σημάτων σε Πραγματικό Χρόνο",
    code: "ΕΠ11",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "",
    s6: "B",
    semester: "7"
  },
  {
    name: "Σχεδίαση VLSI Κυκλωμάτων",
    code: "ΕΠ01",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "B",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Τεχνολογίες της Πληροφορίας και των Επικοινωνιών (ΤΠΕ) στη Μάθηση",
    code: "ΥΣ15",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Υπολογιστική Πολυπλοκότητα",
    code: "ΘΠ20",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Ψηφιακές Επικοινωνίες",
    code: "ΕΠ04",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "B",
    s6: "",
    semester: "7"
  },
  {
    name: "Ψηφιακή Προσβασιμότητα και Υποστηρικτικές Τεχνολογίες Πληροφορικής",
    code: "ΥΣ22",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Αλγοριθμική Επίλυση Προβλημάτων",
    code: "ΘΠ24",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ανάπτυξη Υλικού-Λογισμικού για Ενσωματωμένα Συστήματα",
    code: "Κ23δ",
    ECTS: "8",
    category: "P",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ασύρματες Zεύξεις",
    code: "ΕΠ13",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Διοίκηση Έργων και Τεχνικές Παρουσίασης και Συγγραφής Επιστημονικών Εκθέσεων",
    code: "ΓΠ05",
    ECTS: "2",
    category: "ΓΠ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Επικοινωνιών και Επεξεργασίας Σήματος: Γραμμές μεταφοράς, κυματοδηγοί και οπτικές ίνες",
    code: "ΕΠ22γ",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Επικοινωνιών και Επεξεργασίας Σήματος: Ειδικά Θέματα Κβαντικής Μηχανικής Μάθησης",
    code: "ΕΠ22ε",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Θεωρητικής Πληροφορικής: Αλγόριθμοι Δομικής Βιοπληροφορικής",
    code: "ΘΠ16δ",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Υπολογιστικών Συστημάτων και Εφαρμογών",
    code: "ΥΣ16",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Υπολογιστικών Συστημάτων και Εφαρμογών: Υπολογιστικά Συστήματα Μεγάλης Κλίμακας",
    code: "ΥΣ16α",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ειδικά Θέματα Υπολογιστικών Συστημάτων και Εφαρμογών: Αξιόπιστα Συστήματα Λογισμικού",
    code: "ΥΣ16β",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Επεξεργασία Εικόνας",
    code: "ΕΠ10",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "8"
  },
  {
    name: "Επεξεργασία Ομιλίας και Φυσικής Γλώσσας",
    code: "ΕΠ19",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "8"
  },
  {
    name: "Θεωρία Γραφημάτων",
    code: "ΘΠ10",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Ιστορία της Πληροφορικής και των Τηλεπικοινωνιών",
    code: "ΥΣ20",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Καινοτομία και Επιχειρηματικότητα",
    code: "ΥΣ12",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Κρυπτογραφία",
    code: "ΘΠ05",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Μικροοικονομική Ανάλυση",
    code: "ΕΠ24",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Μουσική Πληροφορική",
    code: "ΕΠ21",
    ECTS: "4",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "B",
    semester: "8"
  },
  {
    name: "Παράλληλοι Αλγόριθμοι",
    code: "ΘΠ19",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Προστασία και Ασφάλεια Υπολογιστικών Συστημάτων",
    code: "ΥΣ13",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Σημασιολογία Γλωσσών Προγραμματισμού",
    code: "ΘΠ16α",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Σχολική Τάξη & Μικροδιδασκαλία",
    code: "ΥΣ21",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Τεχνολογία Λογισμικού",
    code: "ΥΣ09",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "B",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Υπολογιστική Γεωμετρία",
    code: "ΘΠ11",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "7"
  },
  {
    name: "Υπολογιστική Θεωρία Μηχανικής Μάθησης",
    code: "ΘΠ23",
    ECTS: "6",
    category: "ΠΜ",
    s1: "B",
    s2: "B",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Φωτονική",
    code: "ΕΠ12",
    ECTS: "6",
    category: "ΠΜ",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    semester: "8"
  },
  {
    name: "Πρακτική 1",
    code: "ΠΡ1",
    ECTS: "8",
    category: "Π",
    semester: "8",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Πρακτική 2",
    code: "ΠΡ2",
    ECTS: "8",
    category: "Π",
    semester: "8",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },  {
    name: "Πτυχιακή 1",
    code: "ΠΤ1",
    ECTS: "8",
    category: "Π",
    semester: "8",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  },
  {
    name: "Πτυχιακή 2",
    code: "ΠΤ2",
    ECTS: "8",
    category: "Π",
    semester: "8",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  }
]
export const allSemesters = [
  { label: "1st", value: "1" },
  { label: "2nd", value: "2" },
  { label: "3rd", value: "3" },
  { label: "4th", value: "4" },
  { label: "5th", value: "5" },
  { label: "6th", value: "6" },
  { label: "7th", value: "7" },
  { label: "8th", value: "8" }
];

export const allCategories = [
    { label: "Υποχρεωτικό", value: "ΥΜ" },
    { label: "Αυτοτελές Προαιρετικό Εργαστήριο", value: "ΕΡ" },
    { label: "Κατ'επιλογήν υποχρεωτικό", value: "ΕΥΜ" },
    { label: "Προαιρετικό", value: "ΠΜ" },
    { label: "Γενικής Παιδείας", value: "ΓΠ" },
    { label: "Project", value: "P" },
    { label: "Πτυχιακή/Πρακτική", value: "Π" },
];
